var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.8008,
    height: 10.2773,
    viewBox: "0 0 12.8008 10.2773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.6562 0C11.8401 0 12.8008 0.959683 12.8008 2.14355V8.13379C12.8007 9.31763 11.8401 10.2773 10.6562 10.2773H2.14453C0.960677 10.2773 3.89552e-05 9.31763 0 8.13379V2.14355C7.71531e-06 0.959683 0.960658 0 2.14453 0H10.6562ZM6.66992 6.42578C6.5016 6.51665 6.29915 6.51673 6.13086 6.42578L1.13574 3.72559V8.13379C1.13578 8.6908 1.58751 9.14258 2.14453 9.14258H10.6562C11.2133 9.14258 11.665 8.6908 11.665 8.13379V3.72559L6.66992 6.42578ZM2.14453 1.13477C1.58749 1.13477 1.13575 1.58651 1.13574 2.14355V2.43457L6.40039 5.28125L11.665 2.43457V2.14355C11.665 1.58651 11.2133 1.13477 10.6562 1.13477H2.14453Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3dcb8f063905c13ff7986a8c23c8dab9.svg";
export { ForwardRef as ReactComponent };